import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import config from '../../../config';

function SharedAccessManagement() {
    useEffect(() => {
        const url = config.app.qlrvWebUrl;

        if (url) {
            // Open external URL in new tab
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }, []);

    const url = config.app.qlrvWebUrl;

    if (!url) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    gap: 2,
                }}
            >
                <Typography variant="h6" color="error">
                    URL chưa được cấu hình
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Vui lòng cấu hình REACT_APP_QLRV_WEB trong file .env
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                gap: 2,
            }}
        >
            <Typography variant="body1" color="text.secondary">
                Đang mở trang web trong tab mới...
            </Typography>
        </Box>
    );
}

export default SharedAccessManagement;
